import React, { Component } from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import styled from 'styled-components';
import TopScreen from './TopScreen';
import ResultScreen from './ResultScreen';
import PrivacyScreen from './PrivacyScreen';
import ScrollToTop from './ScrollToTop';

const MainContainer = styled.div`
  background: #f9f5f4;
  height: 100%;
  font-family: "Helvetica", "Arial", YuGothic,"Yu Gothic","Hiragino Sans","ヒラギノ角ゴシック","メイリオ", Meiryo,"ＭＳ Ｐゴシック","MS PGothic",sans-serif;
`;

class App extends Component {
  // onChangeに渡すコールバック
  handleLocationChange = (prevState, nextState) => {
    if (nextState.location.action !== "POP") {
      window.scrollTo(0, 0);
    }
  };

  render() {
    return (
      <BrowserRouter>
        <ScrollToTop>
          <MainContainer>
            <Route exact path='/' component={TopScreen} onChange={this.handleLocationChange} />
            <Route exact path='/result' component={ResultScreen} onChange={this.handleLocationChange} />
            <Route exact path='/privacy-policy' component={PrivacyScreen} onChange={this.handleLocationChange} />
          </MainContainer>
        </ScrollToTop>
      </BrowserRouter>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js